// Phase 25 iter-5e — farms client.
//
// Backend (backend/src/routes/v1/farms.ts):
//   GET   /api/v1/farms/me     → FarmResponse | null
//   POST  /api/v1/farms        → FarmResponse  (create)
//   PATCH /api/v1/farms/:id    → FarmResponse  (update)

import {
  API_VERSION_PREFIX,
  type CreateFarmRequest,
  type FarmResponse,
  type UpdateFarmRequest,
} from '@leyrochain/shared';

import { apiClient } from './client';

export async function getMyFarm(): Promise<FarmResponse | null> {
  try {
    const { data } = await apiClient.get<FarmResponse>(`${API_VERSION_PREFIX}/farms/me`);
    return data;
  } catch (err) {
    // 404 cando aínda non hai farm — devolvemos null para que o caller pinte
    // un estado vacío en lugar dunha pantalla de erro.
    if ((err as { response?: { status?: number } }).response?.status === 404) return null;
    throw err;
  }
}

export async function createFarm(input: CreateFarmRequest): Promise<FarmResponse> {
  const { data } = await apiClient.post<FarmResponse>(`${API_VERSION_PREFIX}/farms`, input);
  return data;
}

export async function updateFarm(id: string, input: UpdateFarmRequest): Promise<FarmResponse> {
  const { data } = await apiClient.patch<FarmResponse>(`${API_VERSION_PREFIX}/farms/${id}`, input);
  return data;
}
